/*
  Kiwi Ears · press & reviews library (Rene 2026-08-31) — sections/pr-coverage.

  IT TOGGLES MARKUP, IT NEVER BUILDS A CARD. Every press and store card is a
  customizer block server-rendered by the section; this file only decides
  which cards show. Mode chips are server-rendered; the product chips are
  DERIVED from the cards' data-product attributes so a filter can never be
  offered with nothing behind it (the fnd-facets contract).
*/
(function () {
  'use strict';
  if (window.__kiwiPress) return;
  window.__kiwiPress = true;

  var root = document.querySelector('[data-pr-lib]');
  if (!root) return;
  var cards = [].slice.call(root.querySelectorAll('[data-pr-card]'));
  var empty = root.querySelector('[data-pr-empty]');
  if (!cards.length) return;
  var state = { mode: '', product: '' };

  /* product chips, derived. Names arrive from two places (typed press
     setting, catalogue-rendered store name) so keys are NORMALIZED —
     trimmed, space-collapsed, NFC, case-folded — before dedup, or "Septet"
     meets "Septet " and the row grows a twin chip (QA finding). Filtering
     compares the same normalized key. */
  function norm(v) {
    v = (v || '').replace(/\s+/g, ' ').trim();
    if (String.prototype.normalize) v = v.normalize('NFC');
    return v;
  }
  cards.forEach(function (c) {
    c.setAttribute('data-product-key', norm(c.getAttribute('data-product')).toLowerCase());
  });
  var wrap = root.querySelector('[data-pr-products]');
  if (wrap) {
    var seen = {};
    var labels = [];
    cards.forEach(function (c) {
      var label = norm(c.getAttribute('data-product'));
      if (!label) return;
      var key = label.toLowerCase();
      if (!seen[key]) { seen[key] = true; labels.push(label); }
    });
    if (labels.length > 1) {
      var mk = function (label, value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cmp-chip';
        b.setAttribute('data-pr-product', value);
        b.setAttribute('aria-pressed', String(value === ''));
        b.textContent = label;
        return b;
      };
      wrap.appendChild(mk(wrap.getAttribute('data-all-label') || 'All products', ''));
      labels.sort(function (a, b) { return a.localeCompare(b); })
        .forEach(function (v) { wrap.appendChild(mk(v, v.toLowerCase())); });
    }
  }

  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var ok = (!state.mode || c.getAttribute('data-mode') === state.mode) &&
               (!state.product || c.getAttribute('data-product-key') === state.product);
      c.hidden = !ok;
      if (ok) shown++;
    });
    if (empty) empty.classList.toggle('hidden', shown > 0);
  }

  root.addEventListener('click', function (e) {
    var m = e.target.closest('[data-pr-mode]');
    if (m) {
      state.mode = m.getAttribute('data-pr-mode');
      [].slice.call(root.querySelectorAll('[data-pr-mode]')).forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === m));
      });
      apply();
      return;
    }
    var p = e.target.closest('[data-pr-product]');
    if (p) {
      state.product = p.getAttribute('data-pr-product');
      [].slice.call(root.querySelectorAll('[data-pr-product]')).forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === p));
      });
      apply();
    }
  });
})();
